import { ComponentView, ObservableArray } from "binder";
import { DateItem, SplittedDateSelectorViewModel } from "./splittedDateSelector-viewModel"

export class SplittedDateSelectorView extends ComponentView<SplittedDateSelectorViewModel>{
    GetViewUniqueId(): string {
        return "V-B944D7DC-BCF7-4CF5-8E64-8AFDE8224E7A"
    }
    loadHtml(): string {
        let element = require('./splittedDateSelector.html').default;
        let style = require('./splittedDateSelector.less');
        return element;
    }
    constructor() {
       super();
    }

    public set years(v: ObservableArray<DateItem>) { this._years = v; } public get years(): ObservableArray<DateItem> { return this._years;} private _years: ObservableArray<DateItem>;
    public set monthes(v: ObservableArray<DateItem>) { this._monthes = v; } public get monthes(): ObservableArray<DateItem> { return this._monthes;} private _monthes: ObservableArray<DateItem>;
    public set days(v: ObservableArray<DateItem>) { this._days = v; } public get days(): ObservableArray<DateItem> { return this._days;} private _days: ObservableArray<DateItem>;
    public set selectedYear(v: DateItem) { this._selectedYear = v; } public get selectedYear(): DateItem { return this._selectedYear;} private _selectedYear: DateItem;
    public set selectedMonth(v: DateItem) { this._selectedMonth = v; } public get selectedMonth(): DateItem { return this._selectedMonth;} private _selectedMonth: DateItem;
    public set selectedDay(v: DateItem) { this._selectedDay = v; } public get selectedDay(): DateItem { return this._selectedDay;} private _selectedDay: DateItem;
}
